import { createContext, FC, useEffect } from 'react';
import { useApi } from '@repo-level/core-front';

import { useAuthCookies } from 'hooks/authCookies';
import { brandAssets, BrandAssets } from 'api/cms/brandAssets';

export interface CommonUtilsContextData {
  brandAssetsData?: BrandAssets;
  isLiveSpinsAvailable: boolean;
}

export const CommonUtilsContext = createContext<CommonUtilsContextData>(
  null as any
);

export const CommonUtilsContextProvider: FC = ({ children }) => {
  useAuthCookies();

  const isLiveSpinsAvailable = false;

  const [requestBrandAssets, { data: brandAssetsData }] = useApi(brandAssets);

  useEffect(() => {
    requestBrandAssets();
  }, [requestBrandAssets]);

  return (
    <CommonUtilsContext.Provider
      value={{
        brandAssetsData,
        isLiveSpinsAvailable,
      }}
    >
      {children}
    </CommonUtilsContext.Provider>
  );
};
